/**
 * StandInfoGrid.jsx — the grey info pills of a company-portal stand card (#488)
 *
 * Standlarım and the Dekoratör Projeler list each drew their own copy and had drifted apart:
 * Standlarım stopped at four pills while Projeler drew seven. Both read the same
 * GET /standTalep/list row (mapRosterRow), so one component serves both; the labels are
 * StandPills' (same tr / en text as portal:standlarim.* and portal:projeler.*, no new keys).
 *
 * Order: category, floor, project type, project structure, area, height, kW. Every pill is
 * hidden when its value is null — nothing is invented: projectType is null on every live row
 * today (so that pill shows nowhere), a stand with no Proje Beyanı has no structure / kW, and
 * a null kW means "never asked for electricity", not "0 kW".
 *
 * `truncate` is for a fixed-width column (Standlarım, 200 px): a long catalogue name such as
 * "Maxima Kare Profil" is cut with an ellipsis and carries its full text as a tooltip instead
 * of spilling into the next column.
 */
import React from "react";
import { Building2, Layers, Maximize2, Package, Puzzle, Ruler, Zap } from "lucide-react";
import {
  InfoBox, STAND_CATEGORY_LABELS, PROJECT_TYPE_LABELS, PROJECT_STRUCTURE_LABELS,
} from "../Projects/StandPills";
import { resolvePillLabel } from "../../services/standOverviewService";

export default function StandInfoGrid({ stand, truncate = false }) {
  const category = resolvePillLabel(stand.standCategory, STAND_CATEGORY_LABELS);
  const projectType = resolvePillLabel(stand.projectType, PROJECT_TYPE_LABELS);
  const structure = resolvePillLabel(stand.projectStructure, PROJECT_STRUCTURE_LABELS);
  return (
    <div
      className="d-grid"
      style={{ gridTemplateColumns: truncate ? "repeat(2, minmax(0, auto))" : "repeat(2, auto)", gap: "6px 8px" }}
    >
      {category && <InfoBox icon={Package} label={category} truncate={truncate} />}
      {stand.floorInfo && <InfoBox icon={Building2} label={stand.floorInfo} truncate={truncate} />}
      {projectType && <InfoBox icon={Layers} label={projectType} truncate={truncate} />}
      {structure && <InfoBox icon={Puzzle} label={structure} truncate={truncate} />}
      {/* standArea is measured from the kroki, not the m² the decorator declared, and is null
          for most fairs — "0 m²" is never printed, the pill just hides. */}
      {stand.standArea != null && <InfoBox icon={Maximize2} label={`${stand.standArea} m²`} truncate={truncate} />}
      {stand.projectHeightNumber != null && <InfoBox icon={Ruler} label={`${stand.projectHeightNumber} m`} truncate={truncate} />}
      {stand.kw != null && <InfoBox icon={Zap} label={`${stand.kw} kW`} truncate={truncate} />}
    </div>
  );
}
